const SessionEndpoint = {
  create ({ email, password }) {
    return {
      url: '/sessions',
      method: 'POST',
      body: JSON.stringify({ auth: { email, password } })
    }
  },
  key () {
    return {
      url: '/new_key',
      method: 'POST',
    }
  },
  refreshToken (key) {
    return {
      url: '/refresh',
      method: 'POST',
      body: JSON.stringify({ key: key })
    }
  }
}

export default SessionEndpoint



// WEBPACK FOOTER //
// ./src/persistence/SessionEndpoint.js